
/**
 * Cache to register colors for the current user
 * @kind cache
 * @class Colors
 * @description Custom lookup cache for Colors
 * @usage let lookup = await Grape.cache.get('Colors');
 */
export default {
	name: 'Colors',
	options: {
		table: 'colors',
		schema: 'public',
		limit: 100
	}
};
